import React, { useContext, useEffect, useState } from "react";

/**
 * This is a custom hook that calculate the size of
 * the window and return it
 */
const useResizeWindow = () => {
  // state variable
  const [size, setSize] = useState(window.innerWidth);

  useEffect(() => {
    window.addEventListener("resize", calculateSize);

    return () => {
      window.removeEventListener("resize", calculateSize);
    };
  }, [size]);

  const calculateSize = () => {
    setSize(window.innerWidth);
  };

  return [size];
};

export default useResizeWindow;
